import { render, staticRenderFns } from "./OrderRefundPendingView.vue?vue&type=template&id=19794c23&scoped=true"
import script from "./OrderRefundPendingView.vue?vue&type=script&lang=js"
export * from "./OrderRefundPendingView.vue?vue&type=script&lang=js"
import style0 from "./OrderRefundPendingView.vue?vue&type=style&index=0&id=19794c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19794c23",
  null
  
)

export default component.exports